module.exports = __webpack_public_path__ + "img/e.275e939a.png";